import _extends from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import React from "react";
import { Box, Flex, LoadingSpinner, TextButton } from "@catchoftheday/cg-components";
import { ReviewItem } from "./ReviewItem";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var ReviewList = function ReviewList(_ref) {
  var reviews = _ref.reviews,
      reviewCount = _ref.reviewCount,
      onShowMore = _ref.onShowMore,
      loading = _ref.loading,
      onClickHelpful = _ref.onClickHelpful;
  var shouldShowMore = !loading && reviews && reviews.length > 0 && reviewCount > 6 && reviews.length < reviewCount;
  return ___EmotionJSX(Flex, {
    flexDirection: "column"
  }, ___EmotionJSX(Box, {
    display: "grid",
    gridTemplateColumns: {
      _: "repeat(1, 1fr)",
      lg: "repeat(2, 1fr)"
    },
    gap: {
      _: 4,
      lg: 8
    },
    columnGap: 6,
    borderBottom: "1px solid",
    borderColor: "grey",
    pb: 8
  }, reviews && reviews.length > 0 && reviews.map(function (review, index) {
    return ___EmotionJSX(Box, {
      key: index,
      width: {
        _: "100%",
        lg: "50%"
      }
    }, ___EmotionJSX(ReviewItem, _extends({}, review, {
      onClickHelpful: onClickHelpful
    })));
  })), loading && ___EmotionJSX(Flex, {
    justifyContent: "center",
    alignItems: "center",
    py: "20px",
    flex: "1"
  }, ___EmotionJSX(LoadingSpinner, null)), shouldShowMore && ___EmotionJSX(Flex, {
    justifyContent: "center",
    py: "20px",
    flex: "1"
  }, ___EmotionJSX(TextButton, {
    onClick: onShowMore
  }, "Show more...")));
};